<template>
  <div class="home">
    <el-container>
      <el-aside width="150px">
        <div class="x-flex x-row-center x-p-t-30 x-p-b-20"><img src="../assets/img/logo.png"></div>
        <el-menu :default-active="activerouter" :unique-opened='false' :default-openeds="openeds" @open="handleOpen">
          <el-menu-item class="sy-nav" index="/sy/sy" @click="pushBreadCrumb('首页')">
            <span slot="title">
              <!-- <div class="x-flex x-col-center"> -->
              <img src="../assets/img/sy_icon.png">
              <span class="">首页</span>
              <!-- </div> -->
            </span>
          </el-menu-item>
          <div v-for="(item,index) in navList" :key='index'>
            <el-submenu :index="item._id.toString()">
              <span slot="title">
                <!-- <div class="x-flex x-col-center"> -->
                <img :src="item.img">
                <span class="">{{item.name}}</span>
                <!-- </div> -->
              </span>
              <el-menu-item-group v-for="(itemChildren,itemIndex) in item.children" :key='itemIndex'>
                <el-menu-item :index="itemChildren.path" @click='pushBreadCrumb(item,itemChildren)'>
                  {{itemChildren.name}}
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </div>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class='x-flex x-row-between'>
          <el-breadcrumb separator="/">
            <!-- :to="{ path:breadcrumbList.path }" -->
            <el-breadcrumb-item v-if="breadcrumbList.item_group !=''">{{breadcrumbList.item_group}}</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path:breadcrumbList.path }" v-if="breadcrumbList.item !=''"><span
                :class=" breadcrumbList.item !='' && breadcrumbList.item1 ==''?'c-cz f600':''">{{breadcrumbList.item}}</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path:breadcrumbList.itemPath }" v-if="breadcrumbList.item1 !=''"><span
                :class=" breadcrumbList.item1 !='' && breadcrumbList.item2 ==''?'c-cz f600':''">{{breadcrumbList.item1}}</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item v-if="breadcrumbList.item2 !=''"><span
                :class=" breadcrumbList.item2 !=''?'c-cz f600':''">{{breadcrumbList.item2}}</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
          <div class="x-flex">

            <div class="x-cur-poi x-p-r-20 downLoad x-flex" @click="isShowDownLoad=true">
              <img src="../assets/img/phone.png">
              <span class="x-p-l-6">下载APP</span>
            </div>
            <span class="x-p-r-20">{{smPayAdmin.orgInfo.compName}}({{smPayAdmin.orgInfo.orgId}})</span>
            <el-dropdown class="x-cur-poi">
              <span class="el-dropdown-link">
                <img style="width: 30px;height: 30px; border-radius: 50%;" src="../assets/img/user_logo.png">
                <span>{{smPayAdmin.orgUserInfo.userName}}({{smPayAdmin.orgUserInfo.userId}})</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native='isShowChangePsw=true'>修改密码</el-dropdown-item>
                <el-dropdown-item @click.native="fToLogin">注销登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <!-- 修改密码弹窗 -->
    <!-- <el-dialog title="提示" :visible.sync="" width="">
      <template slot="title">
        <div class="changPsw">
          <span></span>
        </div>
      </template> -->
    <el-dialog class="manage" top="20vh" width="500px" :visible.sync="isShowChangePsw" :show-close="false"
      :close-on-click-modal="false">
      <div class=" x-flex x-row-between  x-p-l-15 x-p-r-15  x-bd-bottom-E">
        <div class='x-flex x-h50 x-cur-poi x-m-r-20'>修改密码</div>
        <div class="x-flex">
          <i class="el-icon-close x-font-16 x-p-2 " style="cursor: pointer; color:#808080 ;" @click="fQxChgPsw"></i>
        </div>
      </div>
      <div class="x-p-l-30 x-p-r-30">
        <div class="x-flex x-p-b-20 x-p-t-20">
          <div class='x-w60'>旧密码</div>
          <el-input :show-password='true' type='passworld' placeholder='请输入当前密码' :clearable='true' v-model="oldPsw">
          </el-input>
        </div>
        <div class="x-flex x-p-b-20">
          <div class='x-w60'>新密码</div>
          <el-input :show-password='true' type='passworld' placeholder='密码长度8位以上 必须包含大小写字母,数字和特殊字符' :clearable='true'
            v-model="newPsw"></el-input>
        </div>
        <div class="x-flex x-p-b-20">
          <div class='x-w60'>新密码</div>
          <el-input :show-password='true' type='passworld' placeholder='密码长度8位以上 必须包含大小写字母,数字和特殊字符' :clearable='true'
            v-model="newPsw1"></el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size='small' @click="fQxChgPsw">取 消</el-button>
        <el-button size='small' type="primary" @click="fSave">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 下载app弹窗 -->
    <el-dialog title="提示" :visible.sync="isShowDownLoad" width="800px">
      <template slot="title">
        <div class="changPsw">
          <span>下载APP</span>
        </div>
      </template>
      <div class=" x-p-l-30 x-p-r-30 x-p-b-20 x-flex x-row-around x-h400">
        <div class=" x-p-b-20 ">
          <img src="../assets/img/orgDown.png" alt="">
          <div class='x-text-c x-p-t-10'>尚米Pay机构端</div>
        </div>
        <div class=" x-p-b-20">
          <img src="../assets/img/mchDown.png" alt="">
          <div class='x-text-c x-p-t-10'>尚米Pay商户端</div>
        </div>
        <div class=" x-p-b-20">
          <img src="../assets/img/gzhDown.png" alt="">
          <div class='x-text-c x-p-t-10'>尚米官方公众平台</div>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import md5 from 'js-md5'
  import eventBus from '../assets/js/bus.js'
  export default {
    data() {
      return {
        smPayAdmin: {},
        isShowChangePsw: false,
        isShowDownLoad: false,
        oldPsw: '',
        newPsw: '',
        newPsw1: '',
        mustChgPsw: false,
        //导航选中数据
        activerouter: "",
        openeds: ['200', '300'],
        // 面包屑导航
        breadcrumbList: {
          item_group: '',
          item: '',
          item1: '',
          item2: '',
          path: ''
        },
        navList: [
          // {
          //   _id: 100,
          //   name: '首页',
          //   // path:'/sy/sy',
          //   children: [
          //     {
          //     _id: 100001,
          //     path: '/sy/sy',
          //     name: '首页',
          //   },
          //   // {
          //   //   _id: 100002,
          //   //   path: '',
          //   //   name: '页面设计',
          //   // }, {
          //   //   _id: 100003,
          //   //   path: '',
          //   //   name: '数据配置',
          //   // }
          //   ]
          // },
          {
            _id: 200,
            name: '商户管理',
            img: require('../assets/img/Administration_icon.png'),
            children: [{
                _id: 200006,
                path: '/Administration/mallAdmin',
                name: '商户进件',
              },
              {
                _id: 200001,
                path: '/Administration/incom',
                name: '商户管理',
              },
              //   {
              //   _id: 200002,
              //   path: '/Administration/jsJl',
              //   name: '结算记录',
              // },
              {
                _id: 200004,
                path: '/Administration/zfLs',
                name: '支付流水',
              }, {
                _id: 200003,
                path: '/Administration/shFx',
                name: '商户分析',
              },

              //  {
              //   _id: 200005,
              //   path: '/Administration/mdYg',
              //   name: '门店员工',
              // },
            ]
          },
          {
            _id: 300,
            name: '机构管理',
            img: require('../assets/img/subOrg_icon.png'),
            children: [{
                _id: 300001,
                path: '/subOrg/xjDl',
                name: '下级机构',
              }, {
                _id: 300002,
                path: '/subOrg/jyFy',
                name: '交易分佣',
              },
              {
                _id: 300003,
                path: '/subOrg/appForCommission',
                name: '申请佣金',
              },
              {
                _id: 300004,
                path: '/subOrg/jgYg',
                name: '团队管理',
              }
            ]
          },
          // {
          //   _id: 400,
          //   name: '财务管理',
          //   img: require('../assets/img/cwGl.png'),
          //   children: [{
          //     _id: 400001,
          //     path: '/finance/commissionSettlement',
          //     name: '分佣结算',
          //   }, ]
          // },
          {
            _id: 500,
            name: '硬件管理',
            img: require('../assets/img/yjgl.png'),
            children: [{
              _id: 500001,
              path: '/hardWareManage/equioManage',
              name: '设备管理',
            }, ]
          },
        ]
      }
    },
    watch: {
      // mustChgPsw(newVal){
      //   console.log(newVal)
      //   this.isShowChangePsw = !this.isShowChangePsw
      // }
    },
    created() {
      this.smPayAdmin = this.bykApi.global.fGetByPayAdmin()
      this.fMustChgPsw()
      // this.$router.push('/sp/spFl')
      eventBus.$on('fChangeBreadcrumb', (breadcrumbList) => {
        this.breadcrumbList = breadcrumbList
        window.sessionStorage.setItem('breadcrumbList', JSON.stringify(breadcrumbList));
      })
      if (this.smPayAdmin.orgInfo.orgId == '16059501' || this.smPayAdmin.orgInfo.orgId == '160595') {
        this.navList.push({
          _id: 400,
          name: '财务管理',
          img: require('../assets/img/cwGl.png'),
          children: [{
            _id: 400001,
            path: '/finance/commissionSettlement',
            name: '分佣结算',
          }, {
            _id: 400002,
            path: '/finance/orgWaitReqCom',
            name: '待结算单',
          }, ]
        })

      }
      if (this.smPayAdmin.orgInfo.pOrgId == '16059501') {
        this.navList[1].push({
          _id: 300003,
          path: '/subOrg/appForCommission',
          name: '申请佣金',
        })

      }

      // this.breadcrumbList = JSON.parse(window.sessionStorage.getItem('breadcrumbList'));
    },
    mounted() {

      // 页面手动刷新指定路由
      // 获取地址栏中的路由，设置elementui中的导航栏选中状态
      let defaultMenu = window.location.hash.substr(
        window.location.hash.indexOf("/")
      );
      this.activerouter = defaultMenu.split('?')[0];
      // 遍历导航数据 匹配到选中栏 动态渲染面包屑导航
      if (this.activerouter == '/subOrg/jyFy1') {
        this.activerouter = '/subOrg/jyFy';
        this.breadcrumbList.item_group = '机构管理'
        this.breadcrumbList.item = '交易分佣'
        this.breadcrumbList.item1 = '交易分佣详情'
        this.breadcrumbList.item2 = ''
        return
      }
      if (this.activerouter == '/Administration/zfLsXq') {
        this.activerouter = '/Administration/zfLs';
        this.breadcrumbList.item_group = '商户管理'
        this.breadcrumbList.item = '支付流水'
        this.breadcrumbList.item1 = '支付流水详情'
        this.breadcrumbList.item2 = ''
        return
      }
      for (let i = 0; i < this.navList.length; i++) {
        // if(this.navList[i].children.length > 0){
        for (let j = 0; j < this.navList[i].children.length; j++) {
          if (this.navList[i].children[j].path == this.activerouter) {
            return this.breadcrumbList = {
              item_group: this.navList[i].name,
              item: this.navList[i].children[j].name,
              item1: '',
              item2: '',
            }
          }
        }
        // }
      }
    },
    methods: {
      handleOpen(index) {

      },

      //修改密码
      // fShowChangePsw() {

      // },
      // 判断是否拥有权限
      async fTestQx(name, path) {
        // 是  1001  不做权限

      },
      //判断是否需要强制修改
      fMustChgPsw() {
        return //暂不需要
        // console.log(this.smPayAdmin.orgInfo.userPsw)
        if (this.bykApi.smCom.fSmIsEmpty(this.smPayAdmin.orgInfo.userPsw)) {
          return
        }
        let reg =
          /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\\W_!@#$%^&*`~()-+=]+$)(?![0-9\\W_!@#$%^&*`~()-+=]+$)(?![a-zA-Z0-9]+$)(?![a-zA-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9\\W_!@#$%^&*`~()-+=]+$)(?![0-9A-Z\\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\\W_!@#$%^&*`~()-+=]{8,}$/
        let result = reg.test(this.smPayAdmin.orgInfo.userPsw.replace(/\s/g, ""))
        if (!result) {
          this.mustChgPsw = true
          // console.log( this.mustChgPsw)
          this.isShowChangePsw = true
        } else {
          this.smPayAdmin.orgInfo.userPsw = ''
          this.bykApi.global.fSetByPayAdmin(this.smPayAdmin)
        }
      },
      //取消修改密码
      fQxChgPsw() {
        if (this.mustChgPsw) {
          return this.$message("原密码有风险，请修改密码");
        }
        this.isShowChangePsw = false
      },
      //确认修改密码
      async fSave() {

        if (this.bykApi.smCom.fSmIsEmpty(this.oldPsw)) {
          this.$message("请输入旧密码");
          return false;
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.newPsw)) {
          this.$message("请输入新密码");
          return false;
        }
        // let reg =
        //   /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\\W_!@#$%^&*`~()-+=]+$)(?![0-9\\W_!@#$%^&*`~()-+=]+$)(?![a-zA-Z0-9]+$)(?![a-zA-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9\\W_!@#$%^&*`~()-+=]+$)(?![0-9A-Z\\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\\W_!@#$%^&*`~()-+=]{8,}$/
        // let result = reg.test(this.newPsw.replace(/\s/g, ""))
        // // console.log(this.newPsw)
        // if (!result) {
        //   this.$message("密码长度需要8位以上，包含大小写英文字母，数字和特殊字符");
        //   return
        // }
        if (this.bykApi.smCom.fSmIsEmpty(this.newPsw1)) {
          this.$message("请再次输入新密码");
          return false;
        }
        if (this.newPsw != this.newPsw1) {
          this.$message("两次输入新密码不相同");
          return false;
        }

        let res = await this.fOrgUserChgPsw()
        if (res.result != 'sucess') {
          this.$message(res.msg);
          return false;
        }
        this.mustChgPsw = false
        this.smPayAdmin.orgInfo.userPsw = ''
        this.bykApi.global.fSetByPayAdmin(this.smPayAdmin)
        this.$message('修改密码成功')
        this.fToLogin()

      },
      //注销
      fToLogin() {
        this.$router.replace('/login')

      },
      // 点击导航动态生成面包屑
      pushBreadCrumb(item, itemChildren) {

        if (item == '首页') {
          this.breadcrumbList = {
            item_group: '',
            item: '',
            item1: '',
            item2: '',
          }
          this.$router.push('/sy/sy')
        } else {
          //判断权限
          if (this.bykApi.global.fGetByPayAdmin().orgInfo.orgId == this.bykApi.global.fGetByPayAdmin().orgUserInfo
            .userId) {
            this.$router.push(itemChildren.path)
          } else {
            let idx = this.bykApi.global.fGetByPayAdmin().user_auth_info.findIndex(item => {
              return item.auth_name == itemChildren.name
            })
            if (idx != -1) {
              this.$router.push(itemChildren.path)
            } else {
              return this.$message('没有' + itemChildren.name + '的权限')
            }

          }
          this.breadcrumbList = {
            item_group: item.name,
            item: itemChildren.name,
            item1: '',
            item2: '',
            itemPath: '',
            path: itemChildren.path
          }
        }

      },
      //
      fChangeBreadcrumb() {

      },



      // 请求=======================
      // 机构修改密码
      async fOrgUserChgPsw() {
        let reqJson = {}
        reqJson.API_NAME = 'smPayAdminApi'
        reqJson.METHOD_NAME = 'ORG_USER_CHG_PSW'

        reqJson.USER_ID = this.bykApi.global.fGetByPayAdmin().orgUserInfo.userId
        reqJson.OLD_PSW = md5(this.bykApi.global.fGetByPayAdmin().orgUserInfo.userId + this.oldPsw)
        reqJson.NEW_PSW = this.newPsw1
        let res = await this.bykApi.postApi.fPostToSmPayAdminApi(reqJson)
        return res.data
      },

      //请求结束====================


    },
  };
</script>

<style lang="less" scoped>
  .home {
    .changPsw {
      padding: 20px 20px 10px 20px;
      font-weight: 600;
      border-bottom: 1px solid #F5F5F5;

      span {
        margin-right: 30px;
        color: #808080;
        padding-bottom: 10px;
      }

      .is_active {
        color: #131318;
        border-bottom: 1px solid #5673FD;
      }
    }

    .el-container {
      background-color: #F2F4F6;
      height: 100vh;
      overflow-y: hidden;

      /deep/ .is-link {}
    }

    .el-main {
      overflow-y: hidden;
      padding: 10px;
    }

    .el-aside {
      overflow-x: hidden;
      background-color: #23252A;
      // border-right: 0.0625rem solid black;
      color: white;
      height: 100vh;

      /*滚动条样式*/
      &::-webkit-scrollbar {
        width: 7px;
      }

      /*滚动条的轨道*/
      &::-webkit-scrollbar-track {
        background-color: #23252A;
      }

      /*滚动条里面的小方块，能向上向下移动*/
      &::-webkit-scrollbar-thumb {
        background-color: #bfbfbf;
        border-radius: 5px;
        border: 1px solid #23252A;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #A8A8A8;
      }

      &::-webkit-scrollbar-thumb:active {
        background-color: #787878;
      }

    }

    .el-header {
      // border-bottom: 1px solid black;
      background-color: white;
      display: flex;
      align-items: center;

      .downLoad {
        &:hover {
          color: #5673fd;
        }
      }
    }

    // 全局复选框修改  选中颜色
    /deep/.el-checkbox__label {
      padding-left: 5px;
    }

    /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #fff;
      // color: unset;
      border-color: #D8DCE6;
    }

    /deep/.el-checkbox__input.is-checked+.el-checkbox__label {
      color: unset;
    }

    /deep/.el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #D8DCE6;
    }

    /deep/.el-checkbox__inner::after {
      border-color: black;
    }

    //全局选择器高度修改
    /deep/.el-input__inner {
      height: 32px;
    }

    //全局导航样式修改
    /deep/.el-menu-item-group__title {
      padding: 0;
    }

    .el-menu-item.is-active {
      background-color: #5673FD;
      color: #FFFFFF;
    }

    /deep/.el-menu-item {
      width: 150px;
      background-color: #1F2126;
      color: #FFFFFF;

      &:hover {
        // background-color: rgba(86, 115, 253, 0.1) !important;
      }
    }

    .sy-nav {
      background-color: #23252A;
    }

    .el-submenu {
      width: 150px;
    }

    /deep/.el-submenu__title {
      color: #FFFFFF;
      background-color: #23252A;

      /deep/ &:hover {
        background-color: unset !important;
      }
    }

    //全局 按钮
    /deep/ .el-button {
      background-color: #5673FD;
      color: #FFFFFF;
      border-color: #5673FD;

      &:hover {
        background-color: #899efd;
        border-color: #899efd;
      }

      &:active {
        background-color: #6b7bc5;
        border-color: #6b7bc5;
      }
    }

    /deep/.el-button--small {
      // padding: 9px;
      font-size: 14px;
    }

    //全局单选框边距
    /deep/ .el-radio {
      margin-right: 10px
    }

    //全局输入框插槽
    /deep/.el-input-group__append {
      padding: 0 5px;
    }

    /deep/.el-radio__label {
      padding-left: 5px;
    }

    //全局日期选择器 关闭按钮
    // /deep/.el-input__icon .el-range__close-icon{

    // }
    //日期中间 至
    /deep/.el-range-separator {
      width: 14px;
      padding: 0;
      height: unset;
    }

    //全局表格高度
    /deep/ .vxe-header--column {
      padding: 0;
      height: 32px;
    }

    /deep/ .vxe-body--column {
      padding: 0;
      height: 40px;
    }

    // 重置弹框样式
    /deep/ .el-dialog__header {
      padding: 0 !important;
    }

    /deep/ .el-dialog__body {
      padding: 0 !important;
    }

    //全局上传图片组件修改
    /deep/.avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    /deep/.avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }

    /deep/.avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 90px;
      height: 90px;
      line-height: 90px;
      text-align: center;
    }

    /deep/.el-upload--picture-card {
      font-size: 28px;
      color: #8c939d;
      width: 90px;
      height: 90px;
      line-height: 90px;
      text-align: center;
    }

    /deep/.el-upload-list__item {
      color: #8c939d;
      width: 90px;
      height: 90px;
    }

    /deep/.avatar {
      width: 90px;
      height: 90px;
      display: block;
    }

    // /deep/ .el-input__icon {
    //   line-height: unset;
    // }

    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #5673FD;
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue